// extracted by mini-css-extract-plugin
export default {"cls1":"VeloCardForm-Card_cls1__LzQkI","cls2":"VeloCardForm-Card_cls2__g-9vu VeloCardForm-Card_cls1__LzQkI"};